export default __webpack_public_path__ + "static/media/TTLogo.bb737cdf.png";